import React, { useMemo } from 'react'
import { SocialAccount } from 'types/influencer';
import { formatNumber, formatTime } from 'utils/helpers';
import '../style.scss';
import { isNumber } from 'lodash';

interface SocialAccountStatsProps {
    socialAccount: SocialAccount;
    connectionRequired?: boolean;
}

interface StatCell {
    label: string;
    value: string;
}

const SocialAccountStats: React.FC<SocialAccountStatsProps> = ({
    socialAccount,
    connectionRequired = false,
}) => {
    const platform = socialAccount?.platform;

    const stats = useMemo((): StatCell[] => {
        const avgLikes =
            platform === 'ig'
                ? isNumber(socialAccount?.ig?.averages?.likes)
                    ? formatNumber(socialAccount.ig.averages.likes)
                    : 'NA'
                : platform === 'yt' && isNumber(socialAccount?.yt?.averages?.likes)
                  ? formatNumber(socialAccount.yt.averages.likes)
                  : 'NA';

        const avgComments =
            platform === 'ig'
                ? isNumber(socialAccount?.ig?.averages?.comments)
                    ? formatNumber(socialAccount.ig.averages.comments)
                    : 'NA'
                : platform === 'yt'
                  ? isNumber(socialAccount?.yt?.averages?.comments)
                      ? formatNumber(socialAccount.yt.averages.comments)
                      : 'NA'
                  : 'NA';

        const avgViews =
            platform === 'ig'
                ? socialAccount?.ig?.averages?.views
                    ? formatNumber(socialAccount.ig.averages.views)
                    : 'NA'
                : platform === 'yt'
                  ? socialAccount?.yt?.averages?.views
                      ? formatNumber(socialAccount.yt.averages.views)
                      : 'NA'
                  : 'NA';

        const engagementScore = socialAccount?.engagement_score
            ? socialAccount.engagement_score
            : 'NA';

        const avgWatchTime = socialAccount?.ig?.averages?.avg_watch_times
            ? `${formatTime(socialAccount.ig.averages.avg_watch_times)}s`
            : 'NA';

        const authenticity = socialAccount?.authenticity_score
            ? `${socialAccount.authenticity_score}%`
            : 'NA';

        if (connectionRequired) {
            return [
                { label: 'Engg Score', value: engagementScore },
                { label: 'Avg Views', value: avgViews },
                { label: 'Avg Watch Time', value: avgWatchTime },
                { label: 'Authenticity', value: authenticity },
                { label: 'Avg Likes', value: avgLikes },
                { label: 'Avg Comments', value: avgComments },
            ];
        }

        return [
            { label: 'Engg Score', value: engagementScore },
            { label: 'Avg Views', value: avgViews },
            { label: 'Avg Likes', value: avgLikes },
            { label: 'Avg Comments', value: avgComments },
        ];
    }, [connectionRequired, platform, socialAccount]);

    const columnCount = connectionRequired ? 3 : 2;

    return (
        <div
            className={`social-account-stats social-account-stats--cols-${columnCount}`}
            role="list"
        >
            {stats.map((stat) => (
                <div className="social-account-stats__cell" key={stat.label} role="listitem">
                    <p className="social-account-stats__value">{stat.value}</p>
                    <p className="social-account-stats__label">{stat.label}</p>
                </div>
            ))}
        </div>
    );
};

export default SocialAccountStats;
